import { CampsiteDetails } from '~/apps/campsite-details/types'
import { Component, Vue } from '~/utility/pu-class-decorator'
import { getMetaFromRoute } from '~/utility/route'
import { AjaxCampsiteDetailsRepository } from '../../apps/campsite-details/AjaxCampsiteDetailsRepository'
import { logger } from '../../utility/logger'

@Component
export class CampsiteFetchingPage extends Vue {
  campsite: CampsiteDetails
  loading: boolean = true

  validate({ params }) {
    // check we have a slug
    return params.slug && isNaN(params.slug)
  }

  get campsiteSlug() {
    return this.$route.params.slug
  }

  get pitchtypeId(): string | (string | null) {
    return Array.isArray(this.$route.query.pitchtype)
      ? this.$route.query.pitchtype[0]
      : this.$route.query.pitchtype
  }
}

interface CampsiteFetchParams {
  route: {
    params: { slug: string; lang?: string }
    query: Record<string, any>
    path: string
    fullPath: string
    meta?: any[] | Record<string, any>
  }
  error: (params: { statusCode: number; message?: string }) => void
  redirect: (code: number, url: string) => Promise<void>
  defaultAdultsCount: number
}

export async function campsiteFetchingPageAsyncData({
  route,
  error,
  redirect,
  defaultAdultsCount,
}: CampsiteFetchParams) {
  // for client if ssr generated error, skip fetching and show error
  if (process.client) {
    // bit of a hack but it works
    // const isErrorPage = document.querySelector('.error-wrapper') !== null
    // if (isErrorPage) {
    //   return error({ statusCode: 404 })
    // }
  }
  logger('campsiteFetchingPageAsyncData', route.fullPath)
  const repository = new AjaxCampsiteDetailsRepository({
    defaults: { defaultAdultsCount },
  })
  const slug = route.params.slug
  const meta = getMetaFromRoute(route)
  const locale = route.params.lang || 'en-gb'
  try {
    const campsite = await repository.get(slug, locale, route.query)
    if (campsite) {
      // check campsite path and slug
      const oldUrl = route.fullPath.toString()
      const newUrl = oldUrl.replace(
        new RegExp(campsite.path, 'ig'),
        campsite.path,
      )
      if (newUrl !== oldUrl) {
        await redirect(301, newUrl)
        return null
      }
      // check if valid hierarchy
      if (meta.doCheckRoute) {
        let redirectUrl = `/${
          locale !== 'en-gb' ? locale + '/' : ''
        }campsites/${campsite.path}${campsite.slug}/`
        const decodedRoutePath = decodeURIComponent(route.path)
        const decodedRedirectUrl = decodeURIComponent(redirectUrl)
        if (
          decodedRoutePath !== decodedRedirectUrl &&
          decodedRoutePath !== `${decodedRedirectUrl}/` &&
          `${decodedRoutePath}/` !== decodedRedirectUrl
        ) {
          const queryParams = new URLSearchParams(route.query)
          if (queryParams.toString()) {
            redirectUrl += `?${queryParams.toString()}`
          }
          await redirect(301, redirectUrl)
          return null
        }
      }
      return { campsite, loading: false }
    }
    return error({ statusCode: 404 })
  } catch (err) {
    const errorResponse = err as {
      response?: { statusCode?: number; status?: number }
    }
    if (
      errorResponse?.response?.statusCode === 404 ||
      errorResponse?.response?.status === 404
    ) {
      return error({ statusCode: 404 })
    }
    return error({
      statusCode: 500,
      message: String(err),
    })
  }
}
